<template>
  <div>
    <!-- Inline -->
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
        <div class="row" style="justify-content: flex-start">
          <!-- Searchfield -->
          <div class="q-mr-md" style="flex-grow: 1">
            <q-input
              :disable="!hideFilters || activeFilters"
              color="grey-5"
              v-model="searchTerm"
              @input="applyFilters"
              :placeholder="$store.state.stringsStore.strings.module.usergroups.list.filter.label"
            />
          </div>
        </div>
      </div>
      <!-- Invite button -->
      <div class="col-6" style="justify-content: flex-end">
        <q-btn v-if="$store.state.meStore.me.rights.includes(`${permission}.add`)"
          class="capitalize ctrl-button right"
          color="ctrl-turquoise"
          :label="$store.state.stringsStore.strings.action.add"
          icon-right="add"
          @click="$router.push(`${module}/add`)"
        />
        <q-btn v-if="$store.state.meStore.me.rights.includes('usergroups.delete')"
          class="capitalize ctrl-button bg-ctrl-grey right q-mr-md"
          color="ctrl-turquoise"
          :disabled="!rowSelection.length"
          :label="$store.state.stringsStore.strings.list.actions.label"
          :class="{ 'button-active': rowSelection.length }">
            <q-icon size="large" name="mdi-chevron-down"/>
            <i v-show="rowSelection.length" class="counter">{{rowSelection.length}}</i>
            <!-- Direct child of target -->
            <q-popover anchor="bottom middle" self="top middle">
              <q-list link>
                <q-item
                  :class="{ 'disabled': !rowSelection.length }"
                  class="toolbar-list-item" @click.native="removeRows('groups')">
                  <q-icon color="positive" size="large" name="delete"/>
                  {{$store.state.stringsStore.strings.action.remove}}
                </q-item>
              </q-list>
            </q-popover>
        </q-btn>
      </div>
    </div>
    <!-- Data table -->
    <table-overview
      :endpoint="endpoint"
      :responseFormat="'usergroups'"
      :columns="columns"
      :permission="permission"
      :module="module"
      :selectable="true">
    </table-overview>
  </div>
</template>

<script>
import EventBus from '@/event-bus';
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';

// Components
import TableOverview from '@/components/overview/TableOverview.vue';
import common from '../common';

export default {
  name: 'usergroups',
  mixins: [
    filtersMixin,
    common,
  ],
  components: {
    TableOverview,
  },
  data() {
    return {
      selectable: true,
      isLoading: false,
      columns: [
        {
          name: '__slot:general-name',
          title: getString('name'),
          label: 'name',
          sortField: 'name',
          titleClass: 'text-left sortable vcol-xl',
          dataClass: 'text-left vcol-xl',
        },
        {
          name: 'members',
          title: getString('members'),
          label: 'Members',
          titleClass: 'text-left sortable vcol-s',
          dataClass: 'text-left vcol-s',
        },
        {
          name: '__slot:usergroups-datetime',
          title: getString('lastUpdate'),
          label: 'Last Update',
          sortField: 'update',
          titleClass: 'text-left sortable vcol-s',
          dataClass: 'text-left vcol-s',
        },
      ],
      rowSelection: [],
      searchTerm: '',
      filters: {
        name: '',
        email: '',
        active: null,
      },
      hideFilters: true,
    };
  },
  methods: {
    removeRows(key) {
      EventBus.$emit('row-selection:delete', key);
    },
  },
  mounted() {
    EventBus.$on('row-selection:update', (payload) => {
      this.rowSelection = payload;
    });
  },
  destroyed() {
    EventBus.$off('row-selection:update');
  },
};
</script>
